module.exports = __webpack_public_path__ + "img/stick_nature_cascade.8ba717c5.svg";